import React from 'react';

export const IconSmallWarningLegacy: React.FC = (props = {}) => (
    <svg height="24" width="24" fill="none" viewBox="0 0 24 24" {...props}>
        {props.children}
        <path
            d="M11.118 5.654L4.784 17.53A1 1 0 005.667 19h12.666a1 1 0 00.883-1.47L12.882 5.653a1 1 0 00-1.764 0zM11 14v-4h2v4h-2zm0 1v2h2v-2h-2z"
            fill="#374050"
            fillRule="evenodd"
        />
    </svg>
);
